import React, { Component } from 'react'
import { Button, Input, Spinner } from 'reactstrap';
import CheckboxTree from 'react-checkbox-tree';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AlertComponent from "../AlertComponent";


const CancelToken = axios.CancelToken;

class EntitiesTreeView extends Component {
  constructor(props){
    super(props);

    this.source = CancelToken.source();

    this.state = {
      loading: true,
      nodes: [],
      checked: [],
      expanded: [],
      filterText: '',
      nodesFiltered:  []
    }
  }
  
  async componentDidMount() {
    await this.load();
  }
  
  componentWillUnmount() {
    this.source.cancel("Cancel");
  }
  
  load = async () => {
    try {
      const res = await axios({
        url: 'api/entity/with-st',
        method: 'GET',
        cancelToken: this.state.token
      });
      let nodes;

      if (res.data) {
        nodes = (res.data);
      }
      const loading = false

      this.setState({
        nodes,
        nodesFiltered: nodes,
        loading
      })
    }
    catch (err) {
      console.error(err);
    }
  }

  onFilterChange = (e) => {
    this.setState({ filterText: e.target.value }, this.onSearch);
  }

  onSearch = async() => {
    const { filterText, nodes } = this.state;
    const  nodesFiltered = [];
    await this.findNode(nodes, nodesFiltered,  filterText);
    this.setState({
      nodesFiltered,
    })
  }

  findNode = (nodes, nodesFiltered, filterText) => {
    nodes.forEach((n) => {
      if (n.label.toLowerCase().includes(filterText.toLowerCase())) {
        nodesFiltered.push(n);
      } else {
        if (n.children)
          this.findNode(n.children, nodesFiltered, filterText) 
        else 
          return;
      }
    })
  }

  onMarkAll = (markAll) => {
    const nodesFiltered = this.state.nodesFiltered
    const checked = [];
    if (markAll) {
      nodesFiltered.forEach((nodes) => {
        checked.push(nodes.value);
        if (nodes) {
          nodes.children.forEach(children => {
            checked.push(children.value);
            this.markItem(children, checked);
          })
        }
      })
    }
    this.setState({ checked })
    this.props.onChange(checked);
  }

  markItem = (node,  checked) => {
    if (node) {
      if (node.length) {
        node.forEach((n) => {
          checked.push(n.value);
          if (n.children) {
            this.markItem(n.children, checked)
          }
        })
      } else {
        checked.push(node.value);
        if (node.children) {
          this.markItem(node.children, checked)
        }
      }
    }
  }

  onCheck = (checked) => {
    this.setState({ checked })
    this.props.onChange(checked);
  }

  onExpand = (expanded) => {
    this.setState({
      expanded
    })
  }

  onSuccess = (text) => {
    this.props.onApply().call(this);
    return toast.success(text, {
      position: toast.POSITION.BOTTOM_RIGHT
    });
  }

  loader = () => {
    const { t } = this.props;
    return (
      <div id="label-no-entities" role='loader'>
        <div>
          <Spinner color="info" />
        </div>
        <h5>
          {t('EntitiesTreeView.loading')}
        </h5>
      </div>
    )
  }

  render() {
    const { loading, nodesFiltered, checked, expanded, filterText, nodes } = this.state;
    const { t, error } = this.props;

    if (loading) {
      return (
        this.loader()
      )
    } else {
      if (nodes.length > 0) {
        return (
          <div role='entity-tree-view'>
            <div className="input-aside">
              <Input id="search" placeholder={t('EntitiesTreeView.search')} type="text" value={filterText} onChange={this.onFilterChange} />
            </div>
            <div className="aside-options">
              <div>
                <CheckboxTree
                  nodes={nodesFiltered}
                  checked={checked}
                  expanded={expanded}
                  onCheck={checked => this.onCheck(checked)}
                  onExpand={expanded => this.onExpand(expanded)}
                  showExpandAll
                  icons={{
                    check: <span className="rct-icon rct-icon-check" />,
                    uncheck: <span className="rct-icon rct-icon-uncheck" />,
                    halfCheck: <span className="rct-icon rct-icon-half-check" />,
                    expandClose: <span className="rct-icon rct-icon-expand-close" />,
                    expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                    expandAll: <span className="rct-icon rct-icon-expand-all" />,
                    collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                    parentClose: <span className="rct-icon rct-icon-parent-close" />,
                    parentOpen: <span className="rct-icon rct-icon-parent-open" />,
                    leaf: <span className="rct-icon rct-icon-leaf" />,
                  }}
                />
              </div>
            </div>
            <div className="alert">
              <div className="animated">
                <ToastContainer position="top-right" autoClose={5000} style={{ zIndex: 1500 }} closeOnClick />
              </div>
              <AlertComponent
                error={error}
                errorMessage={t("EntitiesTreeView.error")}
              />
            </div>
            <div className="buttons">
              <div className="react-checkbox-tree">
                <div id="button-align-left" className="rct-options">
                  <button aria-label={t("EntitiesTreeView.selectAll")} title={t("EntitiesTreeView.selectAll")} type="button" className="rct-option rct-option-expand-all" onClick={() => this.onMarkAll(true)}><i className="rct-icon rct-icon-check" /></button>
                  <button aria-label={t("EntitiesTreeView.clearSelection")} title={t("EntitiesTreeView.clearSelection")} type="button" className="rct-option rct-option-expand-all" onClick={() => this.onMarkAll(false)}><i className="rct-icon rct-icon-uncheck" /></button>
                </div>
              </div>
              <Button color="success" onClick={() => this.onSuccess(t("EntitiesTreeView.success"))}>{t('EntitiesTreeView.apply')}</Button>
            </div>
          </div>
        )
      } else {
        return (
          <div id="label-no-entities" className="animated fadeIn">
            <h5>{t('EntitiesTreeView.noEntities')}</h5>
          </div>
        )
      }
    }
  }
}


export default withTranslation()(EntitiesTreeView)
